<template>
  <v-col md="10" sm="10" class="text-center text-page-num px-0 py-0" :data-test-id="dataTestId">
    <v-btn
      v-for="(page, index) in pageNumberLinks"
      text
      class="min-w-auto"
      :key="index"
      :class="{ 'page-active': page === currentPage }"
      :data-test-id="`${dataTestId}-item-${page}`"
      @click.stop="setPage(page, index)"
    >
      {{ page }}
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: 'Index',
  props: {
    pageNumberLinks: Array,
    currentPage: Number,
    dataTestId: String
  },
  methods: {
    setPage(page, index) {
      this.$emit('settingPage', { page, index });
    }
  }
};
</script>

<style scoped>
.min-w-auto {
  min-width: auto !important;
}
.text-page-num button {
  color: #58e2c2;
}
button.page-active {
  color: #1b2342;
  pointer-events: none;
  font-weight: bold;
}
</style>
